import { useEffect, useState } from 'react';
import { Splide, SplideSlide, SplideTrack } from '@splidejs/react-splide';
import { screenSize } from 'lib/utils';

/**
 * @param {Object} props
 * @param {Array<Object>} items - a list of slider items with a name and image url
 * @returns slider populated with given images
 */
const NaSlider = ({ items }) => {
  const [isMobile, setIsMobile] = useState(screenSize() < 768);
  const itemsPerPage = isMobile ? 3 : 5;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(screenSize() < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="na__splide">
      <Splide
        hasTrack={false}
        options={{
          perPage: itemsPerPage,
          gap: isMobile ? '1.5rem' : '2rem',
          pagination: true,
          drag: 'free',
          perMove: isMobile ? 1 : 3,
          arrows: items.length > itemsPerPage,
        }}>
        <SplideTrack>
          {items.map(({ name, src, height }) => (
            <SplideSlide key={name.toLowerCase().replace(/\s/g, '')}>
              <img src={src} alt={name} height={height} />
            </SplideSlide>
          ))}
        </SplideTrack>
      </Splide>
    </div>
  );
};
export default NaSlider;
